<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja"class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>GLN - Número Global de Localização</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">

        <div class="row">
        <div class="col-xs-12">
            <h3 class="box-title first">GLN - Número Global de Localização</h3>
        </div>
        </div>
        <div class="row">
            <div class="col-xs-12 static-text">
              <img src="/arquivos/conquistas/certificado.gif" />
            </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "LicenceGNL"
};
</script>
